module.exports = __webpack_public_path__ + "img/ico-single-user-add.cf10e152.svg";